import { Form, Formik } from "formik";
import { useNavigate ,useParams} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Button, FormGroup } from "reactstrap";
import "./index.css";
import { getSignedUrlApiAction, storeMedia } from "../../../services/Store/Actions/appActions";
import SvgImage from "../../Icons/Icons";
import { ClipLoader } from "react-spinners";
import { getDriverList } from "../../../services/Store/Actions/driverslistActions";
import { getUpdateFleet } from "../../../services/Store/Actions/fleetActions";
import { linkFLeet } from "../../../services/Utils/Apis";
import { toast } from "react-toastify";


function RenderVehicleProfile(props) {
    const dispatch = useDispatch();
    const data = {}
    let { id } = useParams();
    const vehicleProfileData = useSelector((state) => state?.fleet?.vehicleProfileData);
  console.log("vehicleProfileData",vehicleProfileData);
  const { advancedVehicleList } = useSelector(
    (state) => state?.fleet
  );
  const vehicle = advancedVehicleList?.filter(
    (element) => element.fleetId == id
  )[0];
  const karzaVehicleData = useSelector((state) => state?.fleet?.karzaVehicleData);
  console.log("vehicle", vehicle, id,karzaVehicleData);

  const [status,setStatus] = useState(false)

  const [imageUrls, setImageUrls] = useState([
    { url: "", name: "" },
  ]);
  const [updateDisable, setUpdateDisable] = useState(true)

  useEffect(() => {
    if (id) {
      if (vehicle?.images?.length > 0) {
        setImageUrls(vehicle?.images);
      }
    } else if (!id) {

    }
  }, [id, []]);
  let removeImageUrlFields = (index) => {
    const newFormValues = imageUrls.filter((item, i) => {
      return index != i;
    });
    console.log("newFormValues", newFormValues);
    setImageUrls(newFormValues);
  };
  let handleChangeImageUrls = (i, value, name) => {
    let newFormValues = [...imageUrls];
    newFormValues[i]["url"] = value;
    newFormValues[i]["name"] = name;
    setImageUrls(newFormValues);
    setUpdateDisable(false)
  };
  let addImageUrlFields = () => {
    console.log("===><<<><><", imageUrls);
    setImageUrls([...imageUrls, { url: "", name: "" }]);
  };
  const [openDriver, setOpenDriver] = useState(false);
  const [searchDriver, setSearchDriver] = useState("");

  const driverList = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.rows
  );
  const driverCount = useSelector(
    (state) => state?.driverlist?.allDrivers?.divers?.count
  );
  useEffect(() => {
    dispatch(
      getDriverList({
        offset: "",
        search: searchDriver,
        minKyc: "",
        sortAs: "",
        sortBy: "",
        limit: 10,
      })
    );
  }, [searchDriver]);
  const documentId = "renderVehicleProfile"
  const notify =  (msg, isError = false) => {
    console.log("ajshgvdkba");
    if(isError){
        toast.error(msg || "failed", {
            toastId: documentId,
        })
    }else{
        toast.success(msg || "success", {
            toastId: documentId,
        })
    }
   
}
    return (
        <div>
        <div>
            <Formik
            // isValid='true'
            enableReinitialize
            // validationSchema={validationSchema}
            initialValues={{
                vrn: vehicle?.regNumber,
                model:karzaVehicleData?.KarzaVehicleId ? karzaVehicleData?.makerModel : vehicle?.model,
                driver: vehicle?.driverName,
                tonnage: karzaVehicleData?.KarzaVehicleId ? (parseInt(karzaVehicleData?.grossVehicleWeight) - parseInt(karzaVehicleData?.unladenWeight)): vehicle?.tonnage ,
                vehicleClass: vehicle?.vehicleCategory ? vehicle?.vehicleCategory : vehicle?.vehicleClass,
                mileage: vehicle?.mileage,
                currentOdometer: vehicle?.currentOdometer,
                driverSalary: vehicle?.driverSalary,
                fuelCapacity: vehicle?.fuelTankCapacity,
                images: vehicle?.images,
                driverId: ""
            }}
            onSubmit={(values) => {
                let imageArr = []
                for (let index = 0; index < imageUrls.length; index++) {
                  const element = imageUrls[index];
                  if(!element?.url || !element?.name) continue;
                  else imageArr.push(element)
                }

                let objVal = {
                    model: values.model || null,
                    tonnage: values.tonnage || null,
                    vehicleClass: values.vehicleClass || null,
                    mileage: values.mileage || null,
                    currentOdometer: values.currentOdometer || null,
                    driverSalary: values.driverSalary || null,
                    fuelTankCapacity: values.fuelCapacity || null,
                    images: imageArr
                };
                console.log("renderVehicleProfileData",values,imageArr,objVal);

                dispatch(
                    getUpdateFleet({fleetId: id, ...objVal}, (res)=> {
                        console.log("getUpdateFleetgetUpdateFleet", res);
                        if(res?.status == 200){
                            notify("Profile Updated Successfully");
                            setUpdateDisable(true)
                        }
                    })
                )
                if(vehicle?.driverName != values.driver && values.driverId){
                    dispatch(
                        linkFLeet({fleetId: id, driverId: values.driverId}, (res)=> {
                            console.log("getUpdateFleetgetUpdateFleet", res);
    
                        })
                    )  
                }
            }}
            >
            {({
                handleBlur,
                handleChange,
                handleSubmit,
                setFieldValue,
                resetForm,
                values,
                touched,
                isValid,
                errors,
            }) => (
                <Form onSubmit={handleSubmit} style={{display:"flex", flexDirection:"column", marginTop: "1rem"}}>
                    
                <FormGroup className="divClass">
                    <FormGroup className="">
                        <div className=" heading3 semiBold">
                            Vehicle number
                        </div>
                        <div className="">
                            <input
                                type="text"
                                id="vrn"
                                className={`searchBar-input1 ${
                                touched.vrn && errors.vrn ? "is-invalid" : ""
                                }`}
                                disabled={true}
                                name="vrn"
                                value={values.vrn}
                                touched={touched.vrn}
                                errors={errors.vrn}
                                placeholder=""
                                autoComplete={"off"}
                            />
                            {/* <div style={{ color: "red" }}>
                            {errors.odometer && touched.odometer ? (
                            <div>*{errors.odometer}</div>
                            ) : null}
                        </div> */}
                        </div>
                    
                    </FormGroup>
                    <FormGroup className="">
                    <div className=" heading3 semiBold">
                    Model
                        </div>
                        <div className="">
                        <input
                            type="text"
                            id="model"
                            className={`searchBar-input1 ${
                            touched.model && errors.model ? "is-invalid" : ""
                            }`}
                            name="model"
                            disabled={karzaVehicleData?.KarzaVehicleId ? true: false}
                            onChange={(event) => {
                            // setSearch(event.target.value);
                            setFieldValue("model", event.target.value, true);
                            setUpdateDisable(false)
                            }}
                            value={values.model}
                            touched={touched.model}
                            errors={errors.model}
                            placeholder=""
                            autoComplete={"off"}
                        />
                        {/* <div style={{ color: "red" }}>
                            {errors.odometer && touched.odometer ? (
                            <div>*{errors.odometer}</div>
                            ) : null}
                        </div> */}
                    </div>

                    </FormGroup>
                    <FormGroup>
                  <label for="driver" className="heading3 semiBold">
                    Driver Name
                  </label>
                  <div
                    className=""
                  >
                    <input
                      className={`searchBar-input1 ${
                        touched.driver && errors.driver ? "is-invalid" : ""
                      }`}
                      type="text"
                      id="driver"
                      name="driver"
                      touched={touched.driver}
                      errors={errors.driver}
                      // onBlur={handleBlur("driver")}
                      onChange={(event) => {
                        setOpenDriver(true);
                        setSearchDriver(event.target.value);
                        setFieldValue("driver", event.target.value, true);
                      }}
                      value={values.driver}
                      // autoFocus
                      placeholder=""
                      autocomplete="off"
                      onFocus={() => {
                        setOpenDriver(true);
                      }}
                      onBlur={() => {
                        setOpenDriver(false);
                      }}
                    />
                  </div>

                  <div style={{ position: "relative" }}>
                    {openDriver ? (
                      <div
                        className="driverSearchContainer containerShadow"
                        style={{
                          width: "100%",
                          marginTop: "5px",
                          borderRadius: "8px",
                          border: "1px solid #E2E2E2",
                        }}
                      >
                        {driverList?.map((item, i) => {
                          return (
                            <>
                              {item?.Fastag !== null ? (
                                <div
                                  key={i}
                                  className="flexStyling padding8 "
                                  onClick={(event) => {
                                    setOpenDriver(false);
                                    // setUserId(event.target.value);
                                    setFieldValue(
                                      "driver",
                                      item?.User?.fullName,
                                      true
                                    );
                                    setFieldValue(
                                      "driverId",
                                      item?.driverId,
                                      true
                                    );
                                    setUpdateDisable(false)

                                  }}
                                  onMouseDown={(e) => e.preventDefault()}
                                >
                                  <input
                                    type="radio"
                                    name="driver"
                                    value={item?.driverId}
                                    id={item?.driverId}
                                  />
                                  <div className="padding16L">
                                    {item?.User?.fullName.length > 35
                                      ? item?.User?.fullName.split(0, 35) +
                                        "..."
                                      : item?.User?.fullName}
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </>
                          );
                        })}
                        {driverCount == 0 ? (
                          <div className="heading3 semiBold padding16 padding24B">
                            No driver Available
                          </div>
                        ) : driverCount == undefined ? (
                          <div className="heading3 semiBold padding16 padding24B">
                            No driver Available
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    ) : (
                      <></>
                    )}
                    {/* <div style={{ margin: "7px 0 0px 96px", color: "red" }}>
                      {errors.userId && touched.userId ? (
                        <div>*{errors.userId}</div>
                      ) : null}
                    </div> */}
                  </div>
                </FormGroup>
                </FormGroup>
                <FormGroup className="divClass">
                <FormGroup className="">
                    <div className=" heading3 semiBold">
                    Tonnage
                        </div>
                        <div className="">
                        <input
                            type="text"
                            id="tonnage"
                            className={`searchBar-input1 ${
                            touched.tonnage && errors.tonnage ? "is-invalid" : ""
                            }`}
                            name="tonnage"
                            disabled={karzaVehicleData?.KarzaVehicleId ? true: false}
                            onChange={(event) => {
                            // setSearch(event.target.value);
                            setFieldValue("tonnage", event.target.value, true);
                            setUpdateDisable(false)

                            }}
                            value={values.tonnage}
                            touched={touched.tonnage}
                            errors={errors.tonnage}
                            onBlur={handleBlur("tonnage")}
                            placeholder=""
                            autoComplete={"off"}
                        />
                        {/* <div style={{ color: "red" }}>
                            {errors.odometer && touched.odometer ? (
                            <div>*{errors.odometer}</div>
                            ) : null}
                        </div> */}
                        </div>
                        
                    
                    </FormGroup>
                    <FormGroup className="">
                    <div className=" heading3 semiBold">
                    Vehicle Class
                        </div>
                        <div className="">
                        <input
                            type="text"
                            id="vehicleClass"
                            className={`searchBar-input1 ${
                            touched.vehicleClass && errors.vehicleClass ? "is-invalid" : ""
                            }`}
                            name="vehicleClass"
                            disabled={vehicle?.vehicleCategory ? true: false}
                            onChange={(event) => {
                            setFieldValue("vehicleClass", event.target.value, true);
                            setUpdateDisable(false)

                            }}
                            value={values.vehicleClass}
                            touched={touched.vehicleClass}
                            errors={errors.vehicleClass}
                            placeholder=""
                            autoComplete={"off"}
                        />
                        {/* <div style={{ color: "red" }}>
                            {errors.odometer && touched.odometer ? (
                            <div>*{errors.odometer}</div>
                            ) : null}
                        </div> */}
                    </div>

                    </FormGroup>
                    <FormGroup className="">
                    <div className=" heading3 semiBold">
                    Mileage
                        </div>
                        <div className="">
                        <input
                            type="text"
                            id="mileage"
                            className={`searchBar-input1 ${
                            touched.mileage && errors.mileage ? "is-invalid" : ""
                            }`}
                            name="mileage"
                            onChange={(event) => {
                            setFieldValue("mileage", event.target.value, true);
                            setUpdateDisable(false)

                            }}
                            value={values.mileage}
                            touched={touched.mileage}
                            errors={errors.mileage}
                            placeholder=""
                            autoComplete={"off"}
                        />
                        {/* <div style={{ color: "red" }}>
                            {errors.mileage && touched.mileage ? (
                            <div>*{errors.mileage}</div>
                            ) : null}
                        </div> */}
                    </div>

                    </FormGroup>
                </FormGroup>
                <FormGroup className="divClass">
                <FormGroup className="">
                    <div className=" heading3 semiBold">
                        Current Odometer:
                        </div>
                        <div className="">
                        <input
                            type="text"
                            id="currentOdometer"
                            className={`searchBar-input1 ${
                            touched.currentOdometer && errors.currentOdometer? "is-invalid" : ""
                            }`}
                            name="currentOdometer"
                            onChange={(event) => {
                            // setSearch(event.target.value);
                            setFieldValue("currentOdometer", event.target.value, true);
                            setUpdateDisable(false)

                            }}
                            value={values.currentOdometer}
                            touched={touched.currentOdometer}
                            errors={errors.currentOdometer}
                            placeholder=""
                            autoComplete={"off"}
                        />
                        </div>
                    </FormGroup>
                    <FormGroup className="">
                    <div className=" heading3 semiBold">
                    Driver Salary (per km)
                        </div>
                        <div className="">
                        <input
                            type="text"
                            id="driverSalary"
                            className={`searchBar-input1 ${
                            touched.driverSalary && errors.driverSalary? "is-invalid" : ""
                            }`}
                            name="driverSalary"
                            onChange={(event) => {
                            // setSearch(event.target.value);
                            setFieldValue("driverSalary", event.target.value, true);
                            setUpdateDisable(false)

                            }}
                            value={values.driverSalary}
                            touched={touched.driverSalary}
                            errors={errors.driverSalary}
                            placeholder=""
                            autoComplete={"off"}
                        />
                        </div>
                    </FormGroup>
                    <FormGroup className="">
                    <div className=" heading3 semiBold">
                    Fuel Capacity:
                        </div>
                        <div className="">
                        <input
                            type="text"
                            id="fuelCapacity"
                            className={`searchBar-input1 ${
                            touched.fuelCapacity && errors.fuelCapacity? "is-invalid" : ""
                            }`}
                            name="fuelCapacity"
                            onChange={(event) => {
                            // setSearch(event.target.value);
                            setFieldValue("fuelCapacity", event.target.value, true);
                            setUpdateDisable(false)

                            }}
                            value={values.fuelCapacity}
                            touched={touched.fuelCapacity}
                            errors={errors.fuelCapacity}
                            placeholder=""
                            autoComplete={"off"}
                        />
                        </div>
                    </FormGroup>
                </FormGroup>
                <FormGroup  style={{ display: "flex",  flexDirection: "row", paddingLeft: "75px", paddingRight: "20px"  }}>
                <FormGroup className="col-10" >
                      <label for="podUrl" className="heading3 semiBold">
                        Upload Vehicle Images
                      </label>
                      <div className="row">
                        {imageUrls?.map((item, index) => {
                          let img;
                          return (
                            <div className="col-3" style={{ padding: "18px" }}>
                              <div className="miniCard1">
                                {item?.url ? (
                                  <div
                                    className="row"
                                    style={{ textAlign: "center" }}
                                  >
                                    <div
                                      className="col-12"
                                      onClick={() => {
                                        dispatch(
                                          getSignedUrlApiAction(
                                            { key: item?.url },
                                            (res) => {
                                              // setDownloadLoader2(false);
                                              // setLoaderInvoiceId("");
                                              if (res.status == 200) {
                                                setStatus(true);
                                                window.open(res?.data?.data);
                                              }
                                            }
                                          )
                                        );
                                      }}
                                      style={{
                                        textDecoration: "underline",
                                        color: "blue",
                                      }}
                                    >
                                      Click here
                                    </div>
                                    <div className="col-12">
                                      to View the Image
                                    </div>
                                    <div
                                      className="col-12"
                                      style={{
                                        marginTop: "35px",
                                        textDecoration: "underline",
                                        color: "blue",
                                      }}
                                      onClick={() => {
                                        handleChangeImageUrls(
                                          index,
                                          "",
                                          ""
                                        );
                                      }}
                                    >
                                      <text>Change</text>
                                    </div>
                                    <div
                                      className="col-12"
                                      onClick={() => {
                                        removeImageUrlFields(index);
                                      }}
                                    >
                                      <SvgImage name="deleteIcon2" />
                                    </div>
                                  </div>
                                ) : item?.imgName ? (
                                  <div
                                    style={{
                                      zIndex: 10,
                                      textAlign: "center",
                                      marginTop: "50%",
                                    }}
                                  >
                                    {item?.imgName}
                                    <ClipLoader
                                      color={"#2E7C7B"}
                                      loading={true}
                                      size={20}
                                      aria-label="Loading Spinner"
                                      data-testid="loader"
                                    />
                                  </div>
                                ) : (
                                  <>
                                    <p
                                      className="heading4 Regular"
                                      style={{
                                        textAlign: "center",
                                        cursor: "pointer",
                                      }}
                                    >
                                      Upload Images
                                    </p>
                                    <div
                                      style={{
                                        textAlign: "center",
                                        marginTop: "36px",
                                        marginLeft: "16px",
                                      }}
                                    >
                                      <input
                                        type="file"
                                        style={{
                                          width: "40px",
                                          zIndex: 1,
                                          position: "relative",
                                          cursor: "pointer",
                                        }}
                                        // multiple
                                        // accept="image/*"
                                        accept="image/*"
                                        className="add-lr-attachment-many"
                                        onChange={(e) => {
                                          const img = e?.target.files[0];
                                          console.log("image", img?.name);
                                          handleChangeImageUrls(
                                            index,
                                            "",
                                            img?.name
                                          );
                                          const tempArray = Object.assign(
                                            [],
                                            values.docs
                                          );
                                          console.log("sdfwefewwee", tempArray);

                                          if (img == null) {
                                            //clear image
                                            handleChangeImageUrls(
                                              index,
                                              "",
                                              ""
                                            );
                                            //for now  only one supported
                                          } else {
                                            console.log("upload", {
                                              img: img,
                                              uploadType: "aadharFront",
                                              isRes: true,
                                            });
                                            dispatch(
                                              storeMedia(
                                                {
                                                  img: img,
                                                  uploadType: "aadharFront",
                                                  isRes: false,
                                                },
                                                (res) => {
                                                  setStatus(true);
                                                  if (res?.url) {
                                                    console.log("opt", res);
                                                    tempArray.push(
                                                      res?.data?.Location
                                                    );
                                                    //for now  only one supported
                                                    handleChangeImageUrls(
                                                      index,
                                                      res?.url,
                                                      img?.name
                                                    );
                                                  }
                                                }
                                              )
                                            );
                                          }
                                        }}
                                      />
                                      <SvgImage
                                        name="AddAttachment"
                                        height="25"
                                        width="25"
                                        classname="icon-plus"
                                      />
                                    </div>
                                    <div
                                      className="col-12"
                                      onClick={() => {
                                        removeImageUrlFields(index);
                                      }}
                                      style={{
                                        paddingLeft: "40%",
                                      }}
                                    >
                                      <SvgImage name="deleteIcon2" />
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                          );
                        })}
                        <div className="col-3" style={{ padding: "18px" }}>
                          <div
                            className="miniCard1"
                            onClick={() => {
                              addImageUrlFields();
                            }}
                            style={{ textAlign: "center", paddingTop: "48%" }}
                          >
                            + Add Images
                          </div>
                        </div>
                      </div>
                    </FormGroup>
                    <FormGroup style={{alignSelf: "center", alignContent:"center"}}>
                    <Button
                        type="submit"
                        style={{}}
                        outline={true}
                        disabled={updateDisable}
                        className= {updateDisable ? "inActiveTab1 heading3 semiBold": "activeTab1 heading3 semiBold"}> <text> Update Profile</text>
                    </Button> 
                </FormGroup>
                </FormGroup>
                
            </Form>
            )}
            </Formik>
        </div>
    </div>
    )
}
export default RenderVehicleProfile;
